import { render, staticRenderFns } from "./PagoComplementario.vue?vue&type=template&id=6673c598"
import script from "./PagoComplementario.vue?vue&type=script&lang=js"
export * from "./PagoComplementario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6673c598')) {
      api.createRecord('6673c598', component.options)
    } else {
      api.reload('6673c598', component.options)
    }
    module.hot.accept("./PagoComplementario.vue?vue&type=template&id=6673c598", function () {
      api.rerender('6673c598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/formalizacionactas/pagocomplementario/PagoComplementario.vue"
export default component.exports